import { Injectable, Inject } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormEmergencyServicesOptions } from "../Models/Forms/IFormEmergencyServicesOptions";
import { BaseService } from './BaseService';

@Injectable()
export class FormEmergencyServicesOptionsService extends BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = `${baseUrl}api/FormEmergencyServicesOptions`;
  }

  getFormEmergencyServices(id: number) {
    return this._http.get(`${this._baseUrl}/${id}`)
      .map((response: IFormEmergencyServicesOptions) => response as IFormEmergencyServicesOptions)
      .catch(this.errorHandler);
  }

  insertUpdateFormEmergencyServices(formELReclassificationDetails: IFormEmergencyServicesOptions) {
    return this._http.post(`${this._baseUrl}`, formELReclassificationDetails)
      .map((response: IFormEmergencyServicesOptions) => response as IFormEmergencyServicesOptions)
      .catch(this.errorHandler);
  }

  deleteFormEmergencyServices(id) {
    return this._http.delete(`${this._baseUrl}/${id}`)
      .map((response: IFormEmergencyServicesOptions) => response as IFormEmergencyServicesOptions)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}
